import { useContext, useEffect, useState } from "react";
import { ParagraphText, UBAppModal, UBInput } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { unitKB_2 } from "../../../../constants";
import withObservables from "@nozbe/with-observables";
import styles from "./styles.module.css";
import { Box } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const UnitModal = ({ business, open, handleClose, onSave, customUnit, unitState = {}, id = "" }) => {
    const [unitList, setUnitList] = useState([]);
    const [modalUnitState, setModalUnitState] = useState({
        unit: unitState?.unit || '',
        secondary_unit: unitState?.secondary_unit || '',
        unit_conversion: unitState?.unit_conversion || '',
    })
    const [I18n] = useContext(LanguageContext)
    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        setModalUnitState({
            ...modalUnitState,
            ...unitState
        })
    }, [open])

    useEffect(() => {
        const list = customUnit.length ? customUnit.map(item => {
            return {
                label: item.name,
                value: item.name
            }
        }) : []
        setUnitList([...unitKB_2, ...list])
    }, [customUnit.length])

    const handleCreateUnit = async (val, key) => {
        const isExist = unitList.find(item => item.label.toLocaleLowerCase() === val.toLocaleLowerCase());
        setModalUnitState((item) => ({
            ...item,
            [key]: val
        }))
        if (isExist)
            return
        await business.createUnit(val);
        setUnitList([...unitList, { label: val, value: val }])
    }

    const handleOnSave = (modalUnitState) => {
        if (modalUnitState.secondary_unit && modalUnitState.unit && modalUnitState.unit_conversion == 0) {
            showSnackbar({ message: I18n.unit_conversion_error, severity: 'error', toastId: 'unit_conversion_error' })
            return
        }
        triggerLogEvent(analytics, "sb_unit_saved", {
            unit: modalUnitState.unit,
            secondary_unit: modalUnitState.secondary_unit || null,
        });
        onSave(modalUnitState)
    }

    return (
        <UBAppModal
            id="unit_modal"
            open={open}
            header={{ title: "select_unit_type" }}
            footer={[
                {
                    data: {
                        className: `ubSecondaryButton`,
                        title: `${I18n.cancel}`,
                        onClick: () => handleClose(),
                        loading: false,
                        id: `${id}_unit_save`
                    },
                },
                {
                    data: {
                        className: `ubPrimaryButton`,
                        title: `${I18n.confirm}`,
                        onClick: () => handleOnSave(modalUnitState),
                        disabled: modalUnitState.secondary_unit ? modalUnitState.unit_conversion ? false : true : false,
                        loading: false,
                        id: `${id}_unit_save`
                    },

                }]
            }
            className={styles.unitModal}
        >
            <TabAutoComplete
                id="unit_modal_primary_unit"
                list={unitList}
                label={I18n.primary_unit}
                placeholder={I18n.unit_placeholder}
                value={modalUnitState.unit}
                required={true}
                handleSelect={(item) => {
                    if (!item) {
                        setModalUnitState((prev) => ({
                            ...prev,
                            unit: "",
                            unit_conversion: "",
                            secondary_unit: ""
                        }));
                        return;
                    }
                    if (modalUnitState.secondary_unit && item.value === modalUnitState.secondary_unit) {
                        showSnackbar({ message: I18n.primary_unit_cannot_be_same_to_secondary_unit, severity: 'error', toastId: 'primaryUnitError' });
                        return;
                    }
                    setModalUnitState((prev) => ({
                        ...prev,
                        unit: item.value,
                    }));
                }}
                handleCreate={(val) => handleCreateUnit(val, 'unit')}
                asCreate="unit"
                requireSearchToCreate
            />

            <TabAutoComplete
                id="unit_modal_secondary_unit"
                list={unitList}
                label={I18n.secondary_unit}
                placeholder={I18n.secondary_unit_placeholder}
                value={modalUnitState.secondary_unit}
                disabled={!modalUnitState.unit}
                handleSelect={(item) => {
                    if (!item) {
                        setModalUnitState((prev) => ({
                            ...prev,
                            secondary_unit: "",
                            unit_conversion: "",
                        }));
                        return;
                    }
                    if (item.value === modalUnitState.unit) {
                        showSnackbar({ message: I18n.secondary_unit_cannot_be_same_to_primary_unit, severity: 'error', toastId: 'secondaryUnitError' });
                        return;
                    }
                    setModalUnitState((prev) => ({
                        ...prev,
                        secondary_unit: item.value,
                    }));
                }}
                handleCreate={(val) => handleCreateUnit(val, 'secondary_unit')}
                asCreate="secondary unit"
                requireSearchToCreate
            />

            <ParagraphText className={styles.unitModalDesc}>{I18n.unit_modal_desc}</ParagraphText>
            {(modalUnitState.unit && modalUnitState.secondary_unit) &&
                <Box className={styles.conversionRateBox}>
                    <ParagraphText className={`truncateOneLine ${styles.conversionRateText}`}>Conversion rate: <span className={`foundationRedNormalColor ${styles.unitConversation}`}>*</span>&nbsp; {'1'} {modalUnitState.unit} =&nbsp;</ParagraphText>
                    <UBInput inputId="unit_conversion_rate_input" inputClassname="conversionRateInput"
                        value={modalUnitState.unit_conversion}
                        maxLength={8}
                        onChange={(e, value) => {
                            const inputValue = value;
                            if (/^\d*$/.test(inputValue)) {
                                setModalUnitState(item => (
                                    {
                                        ...item,
                                        unit_conversion: inputValue
                                    }
                                ))
                            }
                        }}
                    />
                    <ParagraphText className={'truncateOneLine ${styles.conversionRateText}'}>{modalUnitState.secondary_unit}</ParagraphText>
                </Box>
            }
        </UBAppModal>
    )
}

const enhance = withObservables(['business'], ({ business }) => ({
    customUnit: business.unit.observe()
}));

export default enhance(UnitModal);
